module.exports = __webpack_public_path__ + "assets/img/Spintel-Content-Marketing-w720.c72278ce.jpg";